import {useEffect, useMemo} from 'react';
import SendingPopup from '../../../component/sendingPopup/SendingPopup';
import {useSelector} from 'react-redux';
import {TState} from '../../../redux/store.type';
import {TShow} from '../../../component/prompotionPopup/PromotionPopup';
import useRestartXHR from '../../../hooks/useRestartXHR';
import {createSendingProps} from '../../../component/sendingPopup/services/createSendingProps';
import {useSendData} from '../../../hooks/useSendData';
import InvoiceEmailButtons from './InvoiceEmailButtons';
import {getEmailData} from '../../../redux/branding/brandingActions';
import {useTranslation} from 'react-i18next';
import {sendInvoice} from '../../../redux/cash/cashActions';
import {useSend} from '../../../component/sendingPopup/hooks/useSend';
import {saveMailing} from '../../../redux/mailing/mailingActions';

function InvoiceSendPopup({show}: {show: TShow}) {
    const invoicePostFields = useSelector((state: TState) => state.cash.invoicePostFields);
    const sendingXHR = useSelector((state: TState) => state.cash.sendInvoiceXHR);
    const eid = useSelector((state: TState) => state.event.eid);
    const {t} = useTranslation('mailing');
    const accountName = useSelector((s: TState) => s.account.title);
    const smsMessage = t('invoiceMessageDefaultText', {accountName: accountName || ''});
    const emailBody = t('invoiceEmailBodyDefaultText', {accountName: accountName || ''});

    const currentLang = useSelector((s: TState) => s.branding.currentLang || s.event.lang || 'he');
    const brandingData = useSelector((s: TState) => s.branding.data);
    const billingDefaults = brandingData?.[currentLang]?.billing;
    const getBrandingDataXHR = useSelector((s: TState) => s.branding.getBrandingData?.[`${currentLang}XHR`]);

    // Fetch branding data if not loaded
    useEffect(() => {
        if(!getBrandingDataXHR && !billingDefaults) {
            getEmailData().then();
        }
    }, [getBrandingDataXHR, billingDefaults]);

    const {whatsappData, emailData, smsData, handleDataSave, whatsappTemplate} = useSendData({
        defaultSubject: billingDefaults?.emailSubject || t('invoiceSubjectDefaultText'),
        defaultEmailBody: billingDefaults?.emailContent || emailBody,
        defaultSmsMessage: billingDefaults?.smsContent || smsMessage,
        type: 'invoice',
        hasWhatsapp: false, // remove when whatsapp template is ready
    });

    const saveData = useMemo(() => ({source: 'invoice', eid}), [eid]);
    const {handleSend, handleSave} = useSend({whatsappData, emailData, smsData, show, sendFunction: sendInvoice, saveFunction: saveMailing, data: {postFields: invoicePostFields}, saveData});
    useRestartXHR(sendingXHR, 'cash.sendInvoiceXHR');

    const {whatsappProps, emailProps, smsProps} = createSendingProps({
        whatsappData,
        emailData,
        smsData,
        handleDataSave,
        handleSend,
        handleSave,
        sendingXHR,
        whatsappTemplate,
        variablesType: 'invoice',
        mailingSource: 'invoice',
        emailButtons: <InvoiceEmailButtons />
    });
    
    const amountText = invoicePostFields?.name ?? '';
    
    return (
        <>
            {show.isOpen && (
                <SendingPopup
                    show={show}
                    whatsappProps={whatsappProps}
                    smsProps={smsProps}
                    emailProps={emailProps}
                    amount={1}
                    amountText={amountText}
                    variablesType={'invoice'}
                    allowedList={['email', 'sms']}
                />
            )}
        </>
    );
}

export default InvoiceSendPopup;

